import { app as firebase } from 'configs/fbConfig';

export const createAnalyticsEvent = (name, item) => {
    firebase.analytics().logEvent(name, {
        items: [item]
    });
}